import update from 'immutability-helper';
import { AuthReduxActions } from './Action';

export const EMP_ROLES = {
  Admin: 'Admin',
  Member: 'Member',
};

export const authState: AuthState = {
  isUserLoggedIn: false,
  accessToken: '',
  refreshToken: '',
  role: '',
  userId: '',
  name: '',
  email: '',
  organizationId: '',
  isOrgSelected: false,
  twoFactor: {
    isEnabled: false,
  },
};

const AuthStateReducer = (
  state = authState,
  action: any = { type: '', payload: {} }
): AuthState => {
  switch (action.type) {
    case AuthReduxActions.AUTH_SET_LOGIN_STATUS:
      return update(state, {
        $merge: {
          isExpiritySession: false,
          isRegularLoggingIn: true,
          ExpritySessionMsg: '',
          ...action.payload,
        },
      });
    default:
      return state;
  }
};

export default AuthStateReducer;
